import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    approvalTotalCount(request: any): Promise<AxiosResponse<any>> {
        return new Promise((resolve, reject) => {
            axiosApi.axiosPost('approval/companyreport/count', request)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    },
	approvalCompanyReportList(request: any, sheetType: any): Promise<AxiosResponse<any>> {
        return new Promise((resolve, reject) => {
            axiosApi.axiosPost(`/approval/` + sheetType + `/companyreport/list`, request)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    approvalCompanyReportUpdateStatus(id: any, request: any): Promise<AxiosResponse<any>> {
        return new Promise((resolve, reject) => {
            axiosApi.axiosPost('approval/companyreport/updatestatus/' + id, request)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }
}
